import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { finalize, share, shareReplay, tap } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import *  as  data from './countries.json';
import { Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { CustomThemeUtility } from './customThemeUtil';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { CurrencyUtilityService } from './currency-utility';
declare let $: any;
@Injectable({
  providedIn: 'root',
})
export class SharedService {
  renderer: Renderer2;
  public errorMessage: string = '';
  public zoomSize: any;
  public countries: any = (data as any).default;
  currencySymbol: string;
  // public totalTax = 0;
  // zoomForCountries = environment.zoomForCountry;
  productListForCountries = environment.productListForCountry;
  countryLogoAvailable = ['jamaica', 'barbados'];
  zoomForCountries: any = {
    'United States': 3,
    'Saint Lucia': 9,
    'Canada': 3,
    'Russia': 3,
    'India': 4,
    'Brazil': 3,
    'United Kingdom': 6,
    'Jamaica': 8,
    'The Bahamas': 7,
    'Cayman Islands': 9,
    'Algeria': 4,
    'Barbados': 9,
    'U.S. Virgin Islands': 11,
    'Saint Kitts & Nevis': 9
  }
  apiUrl = environment.apiUrl;
  getallEvents= this.apiUrl+'/getEvents';
  _getSupportedCountry = this.apiUrl + '/getSupportedCountry';
  private cache: any;
  private cachedObservable: Observable<any>;

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private _document: Document,
    private route: ActivatedRoute,
    private custom: CustomThemeUtility,
    private http: HttpClient,
    private currencyUtilityService: CurrencyUtilityService) { }
  private isLoggedIn = new BehaviorSubject([]);
  isLoggedInData = this.isLoggedIn.asObservable();

  setLoginStatus(isLoggedInData) {
    console.log("Setting login status to:", isLoggedInData);
    this.isLoggedIn.next(isLoggedInData);
  }

  public handleError = (error: HttpErrorResponse) => {
    this.errorMessage = error.error ? error.error : error.statusText;
  };

  public setCompletedStep = function (setvalue) {
    localStorage.setItem('completedstep', setvalue);
  };

  public getCompletedStep = function () {
    return localStorage.getItem('completedstep');
  };

  public getTotalTax = function (amount, taxData) {
    let totalTax = 0;
    let actual_amount = amount;

    let total_inclusive_percent = 0;
    for (let i = 0; i < taxData.length; i++) {
      if (taxData[i].inclusive) {
        total_inclusive_percent += taxData[i].percentage;
      }
    }

    if (total_inclusive_percent > 0) {
      actual_amount = (100 * amount) / (100 + total_inclusive_percent);
    }

    for (let k = 0; k < taxData.length; k++) {
      if (!taxData[k].inclusive) {
        totalTax = totalTax + (actual_amount * taxData[k].percentage) / 100;
      }
    }
    return totalTax;
  }

  public getTaxableAmount = function (amount, taxData) {
    let actual_amount = amount;

    let total_inclusive_percent = 0;
    for (let i = 0; i < taxData.length; i++) {
      if (taxData[i].inclusive) {
        total_inclusive_percent += taxData[i].percentage;
      }
    }

    if (total_inclusive_percent > 0) {
      actual_amount = (100 * amount) / (100 + total_inclusive_percent);
    }
    return actual_amount;
  }

  public getZoomForCountry = function (country) {
    if (this.zoomForCountries[country]) {
      return this.zoomForCountries[country];
    } else {
      return 4;
    }
  }

  public getProductForCountry = function (country) {
    if (this.productListForCountries[country]) {
      return this.productListForCountries[country];
    } else {
      return 'year'
    }
  }

  public getCountryNameFromCode = function (code: string) {
    let name = "";
    const i = code ? this.countries.findIndex(x => x.alpha2.toLowerCase() == code.toLowerCase()) : -1;
    name = i >= 0 ? this.countries[i].name : '';
    return name;
  }

  public loadGoogleMapScript() {
    const script = 'https://maps.googleapis.com/maps/api/js?key=' + environment.gmap_key + '&callback=Function.prototype';
    if ($('script[src*="' + script + '"]').length == 0) {
      const Gmap = this.renderer.createElement('script');
      Gmap.type = 'text/javascript';
      Gmap.src = script;
      this.renderer.appendChild(this._document.body, Gmap);
    }
  }

  public bCountryLogoExists(country) {
    if (this.countryLogoAvailable.includes(country)) {
      return true;
    } else {
      return false;
    }
  }

  public handleErrorText(error: HttpErrorResponse, defaultMessage: string) {
    switch (error.status) {
      case 412:
        const errorData = error.error.data.errors;
        let message = '';
        for (const key in errorData) {
          errorData[key].forEach((x) => message = `${message} \n` + x);
        }
        return message;
      case 500:
        return error.error ? this.getErrorString(error.error) : error.statusText;
      case 400:
        return error.error ? error.error : error.statusText;
      case 401:
        return `You are unauthorized`;
      default:
        return defaultMessage;
    }
  }

  getErrorString(str) {
    return str.replace("error:", "");
  }

  public checkThemeInLocalStorage() {
    const theme = JSON.parse(localStorage.getItem('theme'));
    if (theme) {
      document.querySelector('body').classList.add('insurer-theme');
      this.custom.addCustomCss(theme);
    } else {
      document.querySelector('body').classList.remove('insurer-theme');
    }
  }

  setUserTheme(theme) {
    localStorage.setItem('theme', JSON.stringify(theme));
  }

  public createCroneFrequency(type: any, controls: any) {
    let frequency = '';
    try {
      switch (parseInt(type)) {
        case 0:
          frequency = `*${controls.minute == 1 ? '' : '/' + controls.minute} * * * *`;
          break;

        case 1:
          frequency = `0 *${controls.hour == 1 ? '' : '/' + controls.hour} * * *`;
          break;

        case 2:
          frequency = `${controls.minute} ${controls.hour} * * *`;
          break;

        case 3:
          frequency = `${controls.minute} ${controls.hour} * * ${controls.weekDay}`;
          break;

        case 4:
          frequency = `${controls.minute} ${controls.hour} ${controls.day == '31' ? 'L' : controls.day} * *`;
          break;

        case 5:
          frequency = `${controls.minute} ${controls.hour} ${controls.day} ${controls.month} *`;
          break;

        case 6:
          const date = moment.utc(controls.date, "DD-MM-YYYY").toDate();
          const dayOfMonth = date.getDate();
          const month = date.getMonth() + 1;
          const year = date.getFullYear();
          frequency = `${controls.minute} ${controls.hour} ${dayOfMonth} ${month} ? ${year}`;
          break;
      }
      return frequency;
    }
    catch (err) {
      return err;
    }
  }

  loadStates(): Observable<any[]> {
    return new Observable(observer => {
      this.http.get('/assets/states.csv', { responseType: 'text' })
        .subscribe(
          (data: string) => {
            let csvToRowArray = data.split("\n");

            if (csvToRowArray.length < 2) {
              observer.error('CSV data is empty or malformed');
              return;
            }

            const states = [];
            for (let index = 1; index < csvToRowArray.length; index++) {
              let row = csvToRowArray[index].split(",");
              if (row.length < 9) continue;

              let rowData = {
                id: row[0]?.trim(),
                name: row[1]?.trim(),
                country_id: row[2]?.trim(),
                country_code: row[3]?.trim(),
                country_name: row[4]?.trim(),
                state_code: row[5]?.trim(),
                type: row[6]?.trim(),
                latitude: row[7]?.trim(),
                longitude: row[8]?.trim()
              };
              states.push(rowData);
            }

            observer.next(states);
            observer.complete();
          },
          error => {
            observer.error('Error loading CSV: ' + error.message);
          }
        );
    });
  }

  getPayoutAmountForHistoricEvents(
    event: any,
    values: any,
    eventType: any,
    IILimit: any,
    currency = '',
    request: any,
    II_currency: any,
    rate = null
  ) {
    const USDlimit = this.convertToUSD(IILimit, rate, II_currency);
    const limit =
      II_currency === currency
        ? USDlimit
        : this.convertFromUSD(USDlimit, request.exchangeRate, currency);
  
    let rawThresholds = values.thresholds;
    if (typeof rawThresholds === 'string') {
      try { rawThresholds = JSON.parse(rawThresholds); } 
      catch (e) { console.error('Invalid thresholds format:', e); rawThresholds = []; }
    }
    const thresholds = rawThresholds.map((range: string) => {
      const [lowerStr, upperStr] = range.split(' - ');
      return { lower: parseFloat(lowerStr), upper: upperStr === 'Infinity' ? Infinity : parseFloat(upperStr) };
    });
  
    const currencySymbol = this.currencyUtilityService.setCurrencySymbol(currency);
  
    // Parse payouts safely
    let payouts = values.payouts;
    if (typeof payouts === 'string') {
      try { payouts = JSON.parse(payouts); } 
      catch (e) { console.error('Invalid payouts format:', e); payouts = []; }
    }
    payouts = payouts.map((x: any) => parseFloat(x));
  
    let index: any;
    const maxUpper = Math.max(...thresholds.map(t => t.upper));
  
    const formatValue = (num: number) => this.addCommas(this.roundToTwo(num).toString()) + ' ' + currencySymbol;
  
    switch (eventType.toLowerCase()) {
      case 'hurricane':
        const windspeed = parseFloat(event.wind_speed.split(' ')[0]);
        if (windspeed >= maxUpper) return formatValue(limit * 1);
  
        index = thresholds.findIndex(({ lower, upper }) => lower <= windspeed && windspeed <= upper);
        return index !== -1 ? formatValue(limit * payouts[index]) : formatValue(0);
  
      case 'flood':
        const rainfall = parseFloat(event.rainFall.split(' ')[0]);
        if (rainfall >= maxUpper) return formatValue(limit * 1);
  
        index = thresholds.findIndex(({ lower, upper }) => lower <= rainfall && rainfall <= upper);
        return index !== -1 ? formatValue(payouts[index] * limit) : formatValue(0);
  
      case 'earthquake':
        const mg = event.magnitude;
        if (mg >= maxUpper) return formatValue(limit * 1);
  
        index = thresholds.findIndex(({ lower, upper }) => lower <= mg && mg <= upper);
        return index !== -1 ? formatValue(limit * payouts[index]) : formatValue(0);
  
      default:
        return formatValue(0);
    }
  }
  
  
  removeEmojis(value: string): string {
    return value ? value.replace(/[^\w\s-]/g, '') : ''; 
  }
  
  roundToTwo(number: any) {
    return Math.round(number * 100) / 100;
  }

  getEvents(useCache = true): Observable<any> {
    //  if(this.tempObservable.value.length!=0){
    //       return this.eventdata
    //     }
    //     return  this.http.get(this.getallEvents);
    let observable:Observable<any>;
    if(this.cache && useCache){
      observable= of(this.cache);
    }
  
    else if(this.cachedObservable && useCache){
      observable=this.cachedObservable;
    }
    else{
      this.cachedObservable=this.http.get(this.getallEvents).pipe(
        tap(res=>this.cache=res),
        share(),
        finalize(()=>this.cachedObservable=null)
      );
      observable=this.cachedObservable;
    }
    return observable;
  }

  getSupportedCountry() {
    return this.http.get(this._getSupportedCountry);
  }

  addCommas(value: string): string {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  convertToUSD(amount, rate, currency) {
    if (amount == null || amount === '') return 0;

    const cleanAmount = parseFloat(amount.toString().replace(/,/g, ''));
    if (isNaN(cleanAmount) || !rate) return 0;

    if (currency && currency.toLowerCase() === 'usd') {
      return this.roundToTwo(cleanAmount);
    }

    return this.roundToTwo(cleanAmount / rate);
  }

  convertFromUSD(amountUSD, rate, currency) {
    if (amountUSD == null || amountUSD === '') return 0;

    const cleanAmount = parseFloat(amountUSD.toString().replace(/,/g, ''));
    if (isNaN(cleanAmount) || !rate) return 0;

    // If converting to USD, just round
    if (currency && currency.toLowerCase() === 'usd') {
      return this.roundToTwo(cleanAmount);
    }

    return this.roundToTwo(cleanAmount * rate);
  }
}
